export enum DetectorParameterType {
  NUM_VEHICLES = 'NUM_VEHICLES',
  V = 'V',
}
